import __request__ from "routing/request";
export function getConfig(requestOptions) {
  return __request__("GET", "/system/authentication/http-header-auth-config", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function updateConfig(requestOptions) {
  return __request__("PUT", "/system/authentication/http-header-auth-config", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
